import React from "react"
import { useTranslation } from "react-i18next"
import { Modal } from "ui/Modal"
import { Text } from "ui/Typography"
import AddStaffForm from "./AddStaffForm"
import styles from "./AddStaffModal.module.css"

const AddStaffModal = ({ open, onCancel, onSave, userId, staffId, editMode = false, getProfileAction, updateProfileAction, customTitle }) => {
  const [t] = useTranslation()

  const titleText = customTitle ?? (editMode ? t("staff.edit_staff_modal.title") : t("staff.add_staff_modal.title"))

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      width={800}
      closable
      maskClosable={false}
      destroyOnClose
      className={styles.staffModal}
      title={
        <div className={styles.header}>
          <Text className={styles.title} size="24">
            {titleText}
          </Text>
        </div>
      }
    >
      <AddStaffForm
        key={staffId || "new"}
        open={open}
        onCancel={onCancel}
        onSave={onSave}
        userId={userId}
        staffId={staffId}
        editMode={editMode}
        isFullScreen={false}
        getProfileAction={getProfileAction}
        updateProfileAction={updateProfileAction}
      />
    </Modal>
  )
}

export default AddStaffModal
